import { render, staticRenderFns } from "./BLFGC01Component.vue?vue&type=template&id=f57074c4&scoped=true&"
import script from "./BLFGC01Component.vue?vue&type=script&lang=js&"
export * from "./BLFGC01Component.vue?vue&type=script&lang=js&"
import style0 from "./BLFGC01Component.vue?vue&type=style&index=0&id=f57074c4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f57074c4",
  null
  
)

export default component.exports